export const USER_ALLOWED_ROLES = (['Reviewer', 'Editor', 'Admin', 'MetaReviewer'] as const);